export { default } from './ConfirmActionContent';
export { formatConfirmActionContentCopyText } from './ConfirmActionContent.utils';
